import angular from "angular";

let mod = angular
        .module('carsService', [])
        .service('carsService', ['$http', '$q', controller]);

function controller($http, $q) {

    this.getCars = function (depStationCode, arrStationCode, depDateTime, trainNumber) {
        let getCarsRequest = $q.defer();
        $http
            .post('/railways-api/search-cars', {
                DepartureStationCode: depStationCode,
                ArrivalStationCode: arrStationCode,
                DepartureDatetime: depDateTime,
                TrainNumber: trainNumber
            })
            .then(
                function (response) {
                    let carGroups = response.data.res.ForwardDirectionDto.Trains[0].Train.Cars;
                    let result = [];
                    carGroups.forEach(function (carGroup) {
                        let typeSlug = getTypeSlug(carGroup.Type);
                        let typeNumber = getTypeNumber(carGroup.Type);
                        let typeLabel = getTypeLabel(carGroup.Type);
                        let classServiceType = carGroup.ClassService.Type;
                        let classServiceValue = carGroup.ClassService.Value;
                        let tariff = carGroup.Tariff;
                        let tariff2 = carGroup.Tariff2;
                        let tariffService = carGroup.TariffService;
                        let carrierName = carGroup.Carrier.Name;
                        let carsList = getCarsList(carGroup, typeSlug);
                        result.push({
                            typeNumber: typeNumber,
                            typeLabel: typeLabel,
                            typeSlug: typeSlug,
                            classServiceType: classServiceType,
                            classServiceValue: classServiceValue,
                            tariff: tariff,
                            tariff2: tariff2,
                            tariffService: tariffService,
                            carrierName: carrierName,
                            carsList: carsList,
                            genderType: getGenderType(carGroup)
                        });
                    });
                    getCarsRequest.resolve(result);
                },
                function (error) {
                    getCarsRequest.reject(error);
                }
            );
        return getCarsRequest.promise;
    };

    function getGenderType(carGroup) {
        if (carGroup.AddSigns) {
            if (carGroup.AddSigns.indexOf('ЖН') !== -1) {
                return 'female';
            }
        }

        return 'all';
    }

    function getTypeNumber(type) {
        switch (type) {
            case 'Общий':
                return 1;

            case 'Сидячий':
                return 2;

            case 'Плацкартный':
                return 3;

            case 'Купе':
                return 4;

            case 'Мягкий':
                return 5;

            case 'Люкс':
                return 6;
        }
        return null;
    }

    function getTypeSlug(type) {
        switch (type) {
            case 'Общий':
                return 'obwiy';
            case 'Сидячий':
                return 'sitting';
            case 'Плацкартный':
                return 'placcart';
            case 'Купе':
                return 'kupe';
            case 'Мягкий':
                return 'myagkiy';
            case 'Люкс':
                return 'lux';
        }
        return null;
    }

    function getTypeLabel(type) {
        if (type == 'Плацкартный') {
            return 'Плацкарт';
        }
        return type;
    }

    function getCarsList(carGroup, typeSlug) {

        let result = [];

        carGroup.Cars.forEach(function (car) {

            let seatsUndef = car.Seats.SeatsUndef;
            let seatsDn = car.Seats.SeatsDn;
            let seatsLateralDn = car.Seats.SeatsLateralDn;
            let seatsUp = car.Seats.SeatsUp;
            let seatsLateralUp = car.Seats.SeatsLateralUp;

            let hasSeatNumbers = !!car.Places.length;

            let schemaExists = checkSchemaExists(car.schema);

            let seats = hasSeatNumbers ? createSeats(car.Places, car.schema) : null;

            result.push({

                number: car.Number,
                subType: car.SubType,
                freeSeatsCount: +seatsUndef + +seatsDn + +seatsLateralDn + +seatsUp + +seatsLateralUp,
                hasSeatNumbers: hasSeatNumbers,
                seatsDetail: {
                    undef: seatsUndef,
                    dn: +seatsDn + +seatsLateralDn,
                    up: +seatsUp + +seatsLateralUp
                },

                schemaExists: schemaExists,

                seats: seats,
                elRegPossible: !!car.ElRegPossible,

                schema: car.schema

            });
        });

        return result;
    }

    function checkSchemaExists(schema) {
        return !!schema;
    }

    function createSeats(freePlaces, schema) {

        let seats = [];


        if (schema) {
            let schemaPlaces = getSchemaPlaces(schema.schemaInfo);

            seats = schemaPlaces.map((seat) => {
                return {
                    ...seat,
                    number: seat.id,
                    isFree: !!freePlaces.find((freePlace) => parseInt(freePlace) === seat.id),
                };
            });

        } else {
            for (let i = 0; i < freePlaces.length; i++) {
                seats.push({
                    number: +freePlaces[i],
                    isFree: true
                });
            }

        }

        seats = sortSeatsByNumber(seats);

        return seats;
    }

    function sortSeatsByNumber(seats) {
        return seats.sort((a, b) => a.number - b.number);
    }

    function getSchemaPlaces(schemaInfo) {

        let { parameter, additionalElements } = schemaInfo;

        let seats = [];

        if (additionalElements) {
            let headOfCar = additionalElements.find((element) => element.type === "headOfCar");
            if (headOfCar) {
                let { places = [] } = headOfCar;
                seats = [
                    ...seats,
                    ...places,
                ];
            }
        }

        switch (schemaInfo.carType) {
            case 'coupe':
                seats = [
                    ...seats,
                    ...parameter.sections.reduce((seats, section) => [
                        ...seats,
                        ...section.places
                    ], []),
                ];
                break;
            case 'platscard':
                seats = [
                    ...seats,
                    ...parameter.sections.reduce((seats, section) => [
                        ...seats,
                        ...section.places
                    ], []),
                ];
                break;
            case 'sitting':
                seats = [
                    ...seats,
                    ...parameter.places,
                ];
                break;
        }

        return seats;
    }

}

export default mod.name;



// WEBPACK FOOTER //
// ./resources/assets/modules/booking-module/carsService/carsService.js